const mobileSelector = document.querySelector('#mobile_selector_id');

const openSelector = () => {
  mobileSelector.classList.add('mobile_selector_opened');
  let BInStock_button = document.querySelector('#BIS_trigger');
  let buttonToReplace = document.getElementById('BIS_trigger2');
  if (BInStock_button && buttonToReplace) {
      BInStock_button.classList.add("bis-btn-trigger", "btn", "btn--primary", "button--selector--variants");
      buttonToReplace.appendChild(BInStock_button); 
  }
}
const closeSelector = () => {
  mobileSelector.classList.remove('mobile_selector_opened');
  let BInStock_button = document.querySelector('#BIS_trigger');
  let buttonToReplace = document.getElementById('BIS_trigger1');
  if (BInStock_button && buttonToReplace) {
      buttonToReplace.appendChild(BInStock_button);
  }
}



///////////////// COLOR SELECTOR/////////////////////

const  colorSelectorchild = document.querySelector('#color_selector_child');
const  colorselectorParent = document.querySelector('#color_selector_parent');

if(colorSelectorchild !== null)
  colorselectorParent.appendChild(colorSelectorchild);



